import { TalentActionTypes, TalentState, READ_TALENT_TABLE_DATA_REQUEST, READ_TALENT_TABLE_DATA_SUCCESS, READ_TALENT_TABLE_DATA_FAILURE } from "store/reducers/types/dashboard/talent";

const defaultState: TalentState = {
  isLoading: false,
  errorMessage: ""
};

export default function talent(state = defaultState, action: TalentActionTypes): TalentState {
  switch (action.type) {
    case READ_TALENT_TABLE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_TALENT_TABLE_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_TALENT_TABLE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
